import { BackgroundCheckColumns } from '@/backend/features/background-check/shared';
import { getBackgroundCheckShowOnlyExpiringFilters } from '@/backend/features/background-check/utils/backgroundCheckExpirationUtils';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Filter } from '@juvare/platform-shared/features/storage';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';

const searchParamNameShowExpiringOnly = 'showExpiringOnly';

export function useBackgroundCheckExpiringOnlyFilter(): {
    canEnableExpiringOnlyFilter: boolean;
    expiringOnlyFilters: Filter<BackgroundCheckColumns>[];
    isExpiringOnlyFilterChecked: boolean;
    handleShowExpiringOnlyFilterChange: (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
} {
    const { state } = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const isExpiringOnlyFilterChecked = searchParams.get(searchParamNameShowExpiringOnly) === 'true';
    const { backgroundCheckExpirationPeriod } = useSelector(getSettings);

    const filters = React.useMemo(
        () => getBackgroundCheckShowOnlyExpiringFilters(backgroundCheckExpirationPeriod),
        [backgroundCheckExpirationPeriod],
    );
    const canEnableExpiringOnlyFilter = filters.length > 0;
    const expiringOnlyFilters = isExpiringOnlyFilterChecked ? filters : [];

    const handleShowExpiringOnlyFilterChange = React.useCallback(
        (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
            if (!canEnableExpiringOnlyFilter) {
                return;
            }

            const newSearchParams = new URLSearchParams(searchParams);
            if (checked) {
                newSearchParams.set(searchParamNameShowExpiringOnly, 'true');
            } else {
                newSearchParams.delete(searchParamNameShowExpiringOnly);
            }
            setSearchParams(newSearchParams, { replace: true, state });
        },
        [canEnableExpiringOnlyFilter, searchParams, setSearchParams, state],
    );

    return {
        canEnableExpiringOnlyFilter,
        expiringOnlyFilters,
        isExpiringOnlyFilterChecked,
        handleShowExpiringOnlyFilterChange,
    };
}
